import { render, staticRenderFns } from "./hotelEmployeeDetail.vue?vue&type=template&id=4151db4f&scoped=true&"
import script from "./hotelEmployeeDetail.vue?vue&type=script&lang=js&"
export * from "./hotelEmployeeDetail.vue?vue&type=script&lang=js&"
import style0 from "./hotelEmployeeDetail.vue?vue&type=style&index=0&id=4151db4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4151db4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4151db4f')) {
      api.createRecord('4151db4f', component.options)
    } else {
      api.reload('4151db4f', component.options)
    }
    module.hot.accept("./hotelEmployeeDetail.vue?vue&type=template&id=4151db4f&scoped=true&", function () {
      api.rerender('4151db4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/components/hotelEmployeeDetail.vue"
export default component.exports